import React, {createContext, useContext, useEffect, useState} from "react"
import RequestState from "../../../util/RequestState"
import {fetchClubCleanTableRecord, fetchEmployeeList, fetchTableList} from "../../../api/clubCleanTableRecord"
import moment from "moment"
import XLSX from "xlsx"

const initState = {
    cleanRecordListState: RequestState.Loading,
    employeeListState: RequestState.Loading,
    tableListState: RequestState.Loading,
    pageState: {
        count: 10,
        page: 1,
        total: 0
    },
    searchParamState: {
        tableId: 'all',
        employeeId: 'all',
        startTime: moment().startOf('month'),
        endTime: moment(),
    },

    onPageChange: (page, pageSize) => {
    },
    onSearchParamChange: (param) => {
    },
    getCleanRecordList: () => {
    },
    exportCleanRecordList: () => {
    },
    getEmployeeList: () => {
    },
    getTableList: () => {
    }
}

const ClubCleanTableRecordContext = createContext(initState)

export const ClubCleanTableRecordProvider = (props) => {

    const [cleanRecordListState, setCleanRecordListState] = useState(initState.cleanRecordListState)
    const [employeeListState, setEmployeeListState] = useState(initState.employeeListState)
    const [tableListState, setTableListState] = useState(initState.tableListState)
    const [searchParamState, setSearchParamState] = useState(initState.searchParamState)
    const [pageState, setPageState] = useState(initState.pageState)

    const getCleanRecordList = async () => {
        try {
            let param = {
                clubId: sessionStorage.getItem('club_id'),
                tableId: searchParamState.tableId ? searchParamState.tableId : 'all',
                employeeId: searchParamState.employeeId ? searchParamState.employeeId : 'all',
                page: pageState.page,
                count: pageState.count
            }
            if (searchParamState.startTime) {
                param.startTime = searchParamState.startTime.format('YYYY-MM-DD HH:mm:ss')
            }
            if (searchParamState.endTime) {
                param.endTime = searchParamState.endTime.format('YYYY-MM-DD HH:mm:ss')
            }

            setCleanRecordListState(RequestState.Loading)
            const res = await fetchClubCleanTableRecord(param)
            if (res.status !== 1) {
                throw new Error(`获取球台清理列表失败：${res.detail}`)
            }
            setCleanRecordListState(RequestState.Success(res.data.values))
            setPageState(prevState => {
                return {
                    ...prevState,
                    total: res.data.total
                }
            })
        } catch (e) {
            setCleanRecordListState(RequestState.Error(e.message))
        }

    }

    const exportCleanRecordList = async () => {
        try {
            let allData = []
            let param = {
                clubId: sessionStorage.getItem('club_id'),
                tableId: searchParamState.tableId ? searchParamState.tableId : 'all',
                employeeId: searchParamState.employeeId ? searchParamState.employeeId : 'all',
                count: pageState.count
            }
            if (searchParamState.startTime) {
                param.startTime = searchParamState.startTime.format('YYYY-MM-DD HH:mm:ss')
            }
            if (searchParamState.endTime) {
                param.endTime = searchParamState.endTime.format('YYYY-MM-DD HH:mm:ss')
            }

            let currentPage = 1
            let totalPages = 1

            while (currentPage <= totalPages) {
                param.page = currentPage
                const res = await fetchClubCleanTableRecord(param)
                if (res.status !== 1) {
                    throw new Error(`获取球台清理列表失败：${res.detail}`)
                }
                allData = allData.concat(res.data.values)
                totalPages = Math.ceil(res.data.total / pageState.count)
                currentPage++
            }

            // Prepare data for export
            const exportData = allData.map(record => ({
                '桌台名称': record.table_name,
                '开始时间': record.start_time,
                '结束时间': record.end_time,
                '使用时长': moment.utc(record.use_duration * 1000).format('HH:mm:ss'),
                '结束方式': record.type === 1 ? '自动' : '手动',
                '操作人': record.employee_name,
                '来源': record.source === -1 ? '未知来源' : record.source === 1 ? '收银端' : '掌上管家'
            }))

            // Create a worksheet
            const worksheet = XLSX.utils.json_to_sheet(exportData)

            // Create a workbook and add the worksheet
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Clean Records')

            // Write the workbook and trigger a download
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
            const blob = new Blob([excelBuffer], {type: 'application/octet-stream'})
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `桌台打扫记录-${moment().valueOf()}.xlsx`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(url)
        } catch (e) {
            console.error('导出失败:', e.message)
        }
    }

    const getEmployeeList = async () => {
        try {
            setEmployeeListState(RequestState.Loading)
            const res = await fetchEmployeeList({clubId: sessionStorage.getItem('club_id')})
            if (res.status !== 1) {
                throw new Error(`获取员工列表失败：${res.detail}`)
            }
            setEmployeeListState(RequestState.Success(res.data))
        } catch (e) {
            setEmployeeListState(RequestState.Error(e.message))
        }
    }

    const getTableList = async () => {
        try {
            setTableListState(RequestState.Loading)
            const res = await fetchTableList({clubId: sessionStorage.getItem('club_id')})
            if (res.status !== 1) {
                throw new Error(`获取球台列表失败：${res.detail}`)
            }
            setTableListState(RequestState.Success(res.data))
        } catch (e) {
            setTableListState(RequestState.Error(e.message))
        }
    }


    const onPageChange = async (page, pageSize) => {
        setPageState(prevState => {
            return {
                ...prevState,
                page: page,
                count: pageSize
            }
        })
    }

    const onSearchParamChange = (param) => {
        setSearchParamState(prevState => {
            return {
                ...prevState,
                ...param
            }
        })
    }

    useEffect(() => {
        getCleanRecordList()
    }, [pageState.page, pageState.count, searchParamState])


    const value = {
        cleanRecordListState,
        employeeListState,
        tableListState,
        pageState,
        searchParamState,
        onPageChange,
        onSearchParamChange,
        getCleanRecordList,
        exportCleanRecordList,
        getEmployeeList,
        getTableList
    }

    return (
        <ClubCleanTableRecordContext.Provider value={value}>
            {props.children}
        </ClubCleanTableRecordContext.Provider>
    )
}

export const useClubCleanTableRecordContext = () => {
    const context = useContext(ClubCleanTableRecordContext)
    if (context === undefined) {
        throw new Error('useClubCleanTableRecordContext must be used within a ClubCleanTableRecordProvider')
    }
    return context
}


// WEBPACK FOOTER //
// ./src/containers/ClubCleanTableRecord/store/useClubCleanTableRecordContext.js